angular.module('cfn').factory('bookingService', bookingService);

bookingService.$inject = [
  '$log',
  'unitConverter',
  'bookingRules',
  '$rootScope',
  '$http',
  '$q',
  'CfnDialogService',
  'i18nFilter',
  'timeZoneHackService',
  'bookingMaskService',
  'farmnet.FeatureToggleService'
];
function bookingService(
  $log,
  unitConverter,
  bookingRules,
  $rootScope,
  $http,
  $q,
  CfnDialogService,
  i18nFilter,
  timeZoneHackService,
  bookingMaskService,
  toggleService
) {

  // (Re-)calc SUM
  // moduleName: z.B.: 'anteil_sysCultureList'
  let summation = function($scope, moduleName) {
      let sum = $scope.details[moduleName].reduce(
        function(p, c) {
          return {
            area: p.area + parseFloat(c.area || 0),
            amount: p.amount + parseFloat(c.amount || 0),
            grossPrice: p.grossPrice + parseFloat(c.grossPrice || 0)
          };
        },
        { area: 0, amount: 0, grossPrice: 0 }
      );

      // Set SUM-Values
      $scope.details[moduleName + '_area_sum'] = sum.area;
      $scope.details[moduleName + '_amount_sum'] = sum.amount;
      $scope.details[moduleName + '_grossPrice_sum'] = sum.grossPrice;
      $scope.details[moduleName + '_amountPerArea_sum'] = sum.amount / sum.area;
      $scope.details[moduleName + '_grossPricePerArea_sum'] =
        sum.grossPrice / sum.area;
    },
    // Änderung im Feld -> neu berechnen
    // TKM = Tausendkorngewicht (g)
    // KF  = Keimfähigkeit (%)
    // -------------------------------------------------------------------------------------------------------------------
    // Fläche   ->  Menge =     Fläche * Fläche/ha       area               -> amount =               area * amountPerArea
    // Menge    ->  Menge/ha =  Fläche / Menge           amount             -> amountPerArea =        area / amount

    // only Saatgut
    //          ->  Preis =     Menge * Preis/Einheit
    //          ->  Preis/ha =  Preis / Fläche
    // Preis/Einheit ->
    //          ->  Preis =     Menge * Preis/Einheit
    //          ->  Preis/ha =  Preis / Fläche
    // Menge/ha ->  Menge =     Fläche * Menge/ha        amountPerArea      -> amount =               area * amountPerArea
    //          ->  Körner/qm = (Menge/ha * KF) / TKM                       -> amount =               area * amountPerArea;
    // Preis    ->  Preis/ha =  Preis / Fläche           grossPrice         -> grossPricePerArea =    grossPrice / area
    // Preis/ha ->  Preis =     Fläche * Preis/ha        grossPricePerArea  -> grossPrice =           area * grossPricePerArea
    // Körner/qm->  Menge/ha =  (Körner/qm *TKM) / KF
    //          ->  Menge =     Fläche * Menge/ha        amountPerArea      -> amount =               area * amountPerArea
    // TKM      ->  Körner/qm = (Menge/ha * KF) / TKM
    // KF       ->  Körner/qm = (Menge/ha * KF) / TKM
    calculation = function($scope, changedfieldName, item, seedOrCulture) {
      if ($scope.$parent.details.isLoading) {
        return;
      }

      function calcPrice() {
        if (seedOrCulture) {
          item.grossPrice =
            (item.amount || 0) *
            (seedOrCulture.costsGrossPrice || seedOrCulture.grossPrice); // seed.costGrossPrice - culture.grossPrice
          item.grossPricePerArea = item.grossPrice / item.area || 0;
        }
      }

      function calcSeedStrength() {
        if (seedOrCulture) {
          calcPrice();

          if (
            angular.isNumber(seedOrCulture.weight1000) &&
            angular.isNumber(seedOrCulture.germinationCap)
          ) {
            if (
              angular.isNumber(item.amountPerArea) &&
              unitConverter.isCapacity(seedOrCulture.unit)
            ) {
              let amountPerAreaInKg = unitConverter.convertCapacity(
                seedOrCulture.unit,
                'MASS_KG',
                item.amountPerArea
              );

              // Saatstärke berechnen
              item.specialDouble1 =
                amountPerAreaInKg *
                seedOrCulture.germinationCap /
                seedOrCulture.weight1000;
            }
          }

          // CFNPOC-38980 handle QUANTITY_UNIT differently
          if (unitConverter.isUnitQuantity(seedOrCulture.unit)) {
            if (angular.isNumber(item.amountPerArea)) {
              let grainsPerUnit = getGrainsPerUnit(seedOrCulture);
              if (grainsPerUnit) {
                item.specialDouble1 = item.amountPerArea * (grainsPerUnit / 10000);
              }
            }
          }
        }
      }
      function getGrainsPerUnit(seedOrCulture) {
          let grainsPerUnit = 0;
          if (unitConverter.isGrain(seedOrCulture.unit)) {
              grainsPerUnit = 1;               
            } else if (angular.isNumber(seedOrCulture.grainsPerUnit)) {
              grainsPerUnit = seedOrCulture.grainsPerUnit;
            }
          return grainsPerUnit;
      }
      
      

      switch (changedfieldName) {
        case 'area':
          item.amount = item.area * item.amountPerArea;
          calcSeedStrength();
          break;
        case 'amount':
          item.amountPerArea = item.amount / item.area || 0;
          calcSeedStrength();
          break;
        case 'amountPerArea':
          item.amount = item.area * item.amountPerArea;
          calcSeedStrength();
          break;
        case 'costsGrossPrice':
          calcSeedStrength();
          break;
        case 'grossPrice':
          item.grossPricePerArea = item.grossPrice / item.area || 0;
          break;
        case 'grossPricePerArea':
          item.grossPrice = item.area * item.grossPricePerArea;
          break;
        case 'specialDouble1': //Körner/qm
          if (unitConverter.isCapacity(seedOrCulture.unit)) {
            let amountPerAreainKg;

            if (
              angular.isNumber(seedOrCulture.weight1000) &&
              angular.isNumber(seedOrCulture.germinationCap)
            ) {
              amountPerAreainKg =
                item.specialDouble1 *
                seedOrCulture.weight1000 /
                seedOrCulture.germinationCap;
              item.amountPerArea = unitConverter.convertCapacity(
                'MASS_KG',
                seedOrCulture.unit,
                amountPerAreainKg
              );
            }

            item.amount = item.area * item.amountPerArea;
            calcSeedStrength();
          }

          if (unitConverter.isUnitQuantity(seedOrCulture.unit)) {
            let unitsPerArea;
            let grainsPerUnit = getGrainsPerUnit(seedOrCulture);
            if (grainsPerUnit) {
                unitsPerArea = (item.specialDouble1 * 10000) / grainsPerUnit;
                item.amountPerArea = unitsPerArea;
                item.amount = item.area * item.amountPerArea;
            }
          }

          break;
        case 'weight1000': //TKM
          calcSeedStrength();
          break;
        case 'germinationCap': //KF
          calcSeedStrength();
          break;
        case 'grainsPerUnit':
          calcSeedStrength();
          break;
        case 'unit':
          if (unitConverter.isCapacity(seedOrCulture.unit)) {
            let amountPerAreainKg;

            if (
              angular.isNumber(seedOrCulture.weight1000) &&
              angular.isNumber(seedOrCulture.germinationCap)
            ) {
              amountPerAreainKg =
                item.specialDouble1 *
                seedOrCulture.weight1000 /
                seedOrCulture.germinationCap;
              item.amountPerArea = unitConverter.convertCapacity(
                'MASS_KG',
                seedOrCulture.unit,
                amountPerAreainKg
              );
            }

            item.amount = item.area * item.amountPerArea;

            // Prices are converted reciprocally
            if (unitConverter.isCapacity(seedOrCulture.originalUnit)) {
              seedOrCulture.costsGrossPrice = unitConverter.convertCapacity(
                seedOrCulture.unit,
                seedOrCulture.originalUnit,
                seedOrCulture.costsGrossPrice
              );
              seedOrCulture.originalUnit = seedOrCulture.unit;
            }

            calcSeedStrength();
          }
          break;
      }
    },
    mergeFieldList = function($scope, moduleName, onNewCallback) {
      if (!angular.isArray($scope.details.fieldList)) {
        return;
      }

      function removeField(assetId) {
        for (let i = $scope.details[moduleName].length - 1; i >= 0; i -= 1) {
          if ($scope.details[moduleName][i].assetId === assetId) {
            $scope.details[moduleName].splice(i, 1);
          }
        }
      }

      let oldFields = {},
        newFields = {};

      // Zielzustand der liste bestimmen
      $scope.details.fieldList.forEach(function(field) {
        newFields[field.asset.id] = true;
      });

      // aufnehmen welche schlaege bleiben (oldFields[id] true) und welche wegfallen werden (oldFields[id] false)...
      $scope.details[moduleName].forEach(function(field) {
        oldFields[field.assetId] = newFields[field.assetId] === true;
      });

      // ...und wegfallende schlaege aus der liste löschen
      _.each(oldFields, function(val, key) {
        if (val === false) {
          removeField(key);
        }
      });

      // Welche Schläge kamen hinzu?
      $scope.details.fieldList.forEach(function(field) {
        if (!oldFields[field.asset.id]) {
          let newItem = {
            assetId: field.asset.id,
            name: field.asset.name,
            area: field.asset.farmedArea
          };

          if (onNewCallback) {
            onNewCallback(newItem);
          }

          $scope.details[moduleName].push(newItem);
        }
      });
    },
    // enable add of groups additionally to single add (and call single add for each)
    // (Schlaggruppe, Personengruppe)
    enableGroupAdd = function(obType, ob, func) {
      if (obType.toLowerCase() != ob._objectType) {
        // group !
        $http
          .get('/365FarmNet/rest/core/' + ob._objectType + '/' + ob.id)
          .then(function(response) {
            let result = response.data;
            let varName = obType + 'Group_' + obType + 's';
            if (result[varName]) {
              for (let i in result[varName]) {
                let res = result[varName][i];
                if (res[obType]) {
                  func(obType, res[obType]);
                } // call single func for each
              }
            }
          });
      } else {
        func(obType, ob); // call func
      }
    },
    addToList = function($scope, newItem, listName) {
      if ($scope.details[listName]) {
        let alreadyExist = $scope.details[listName].some(function(item) {
          return item.feid === newItem.feid;
        });

        if (!alreadyExist) {
          $scope.details[listName].push(newItem);
        }
      } else {
        $scope.details[listName] = [newItem];
      }
    };

  let harvestHelper = {
    helpUser: false,
    harvestYearFromToday: function() {
      let now = new Date();
      let month = now.getMonth(); //0 index
      let year = now.getFullYear();
      //<1.7 => current otherwise current + 1
      return month < 6 ? year : year + 1;
    }
  };

  // fillHarvestValuesByField
  const fillHarvestInfo = function(fields, date, onCropChange) {
    if (!fields || fields.length == 0) {
      return $q.resolve();
    } else {
      if (!_.isArray(fields)) fields = [fields];
      let data = {
        eventDate: timeZoneHackService.toBackendTimezone(date),
        fieldIds: _.pluck(fields, 'feid')
      };
      let url_fillHarvestInfo = '/365FarmNet/mod/booking-service/booking/operation/rest/v1.0/harvestbookingdata/';

      return $http
        .post(
          url_fillHarvestInfo,
          data
        )
        .then(function(response) {
          let data = response.data;
          let allCrops = _.groupBy(data, 'fieldId');
          _.each(fields, function(field) {
            //what if we have more?

            let cropOnField = _.first(allCrops[field.feid]);

            if (typeof cropOnField === 'undefined') {
              cropOnField = {};
            }

            field.cropOnField = cropOnField;
            field.harvestCropInfo= _.clone(cropOnField);
          });
          bookingMaskService.fieldUpdate();
        });
    }
  };

  // checkTilling
  // https://365farmnet.atlassian.net/browse/CFNPOC-6282
  const checkTilling = function(fields, date, isBooking) {
    if (!bookingRules.isActiveActivity('FIELD', 'tilling') || !isBooking)
      return $q.when(null);

    const data = {
      fields: fields.map(function(field) {
        return field.asset.id;
      }),
      date: date.getTime()
    };
    return $http
      .post('/365FarmNet/rest/booking/tillingdata/', data)
      .then(function(response) {
        return response;
      });
  };

  // Asks a yes/no question and returns a promise. If condition is set, the question is only
  // asked if condition is true. The promise is resolved to:
  // true, if yes was clicked.
  // false, if no was clicked.
  // undefined if the question was not asked or not answered
  const ask = function(prompt, condition) {
    let deferred = $q.defer();

    if (condition === undefined || condition) {
      let title = i18nFilter('fe.booking.request.title', 'Rückfrage'),
        message = i18nFilter(prompt);

      CfnDialogService.showYesNoDialog(
        title,
        message,
        function() {
          // yes gedrückt
          deferred.resolve(true);
        },
        function() {
          // no gedrückt
          deferred.resolve(false);
        },
        function() {
          // not answered
          deferred.resolve(undefined);
        }
      );
    } else {
      // Question not asked
      deferred.resolve(undefined);
    }
    return deferred.promise;
  };

  // Refreshs all entities by reloading them from backend, replacing only non editable-fields
  function updateEntityReadOnlyFields(details) {
    let promises = [];

    function updateEntity(entityType, current) {
      let jsonEntityType =
        entityType[0].toLowerCase() + entityType.substring(1);
      let urlEntityType = entityType.toLowerCase();
      promises.push(
        $http
          .get('/365FarmNet/rest/core/' + urlEntityType + '/flat/' + current.id)
          .then(function(response) {
            let result = response.data;
            let newData = result[jsonEntityType];
            // Apply read-only fields
            // Common fields
            current.invalid = newData.invalid;
            current.number = newData.number;
            // Specific fields
            switch (jsonEntityType) {
              case 'seed':
                current.name = newData.name;
                break;
              case 'field':
                current.name = newData.name;
                current.farmedArea = newData.farmedArea;
                break;
              case 'fertilizer':
                current.nameString = newData.nameString;
                break;
              case 'person':
                current.combinedName = newData.combinedName;
                current.category = newData.category;
                break;
              case 'machine':
                current.name = newData.name;
                break;
            }
          })
      );
    }

    /**
     * Updates each entity in a table
     */
    function updateTable(tableName, typeName) {
      if (details[tableName]) {
        for (let i = 0; i < details[tableName].length; i++) {
          let f = details[tableName][i];
          updateEntity(f[typeName + 'Type'], f[typeName]);
        }
      }
    }

    // Update all entities in all tables
    updateTable('fieldList', 'asset');
    updateTable('seedList', 'supply');
    updateTable('supplies', 'supply');
    updateTable('personList', 'resource');
    updateTable('machineList', 'resource');
    updateTable('resources', 'resource');

    return $q.all(promises);
  }

  // Public
  return {
    summation: summation,
    calculation: calculation,
    mergeFieldList: mergeFieldList,
    enableGroupAdd: enableGroupAdd,
    addToList: addToList,
    harvestHelper: harvestHelper,
    fillHarvestInfo: fillHarvestInfo,
    checkTilling: checkTilling,
    ask: ask,
    updateEntityReadOnlyFields: updateEntityReadOnlyFields
  };
}
